import React, { useState } from "react";
import { TableRow, TableCell, Button } from "@windmill/react-ui";
import WhatsAppServices from "services/WhatsAppServices";
import { notifyError, notifySuccess } from "utils/toast";

const EmailTable = ({
  messagedata,
  handleUpdate,
  handleDelete,
  handleModalOpen,
  hideDelete,
  hideEdit,
}) => {
  const [loadingId, setLoadingId] = useState(null);
  const [safeData, setSafeData] = useState(messagedata || []);
  // console.log("dtaaaaaa", safeData)
  // console.log("loaded id", loadingId)
  const handleCheckClick = async (id) => {
    try {
      setLoadingId(id); 
      const res = await WhatsAppServices.checkMessageStatus(id);
      // console.log("coming data", res)
      // console.log("message id,", id)

      if (res.data && res.data.status) {
        const updatedStatus = res.data.status;

        // Update the status locally in the message table
        setSafeData((prev) =>
          prev.map((msg) =>
            msg.id === id
              ? { ...msg, status: updatedStatus }
              : msg
          )
        );

        notifySuccess("Message status updated");
      } else {
        notifyError("Failed to update message status");
      }
    } catch (err) {
      console.error("Error checking message status:", err);
      notifyError("Error checking message status");
    } finally {
      setLoadingId(null);
    }
  };

  return (
    <>
      {safeData?.map((msg, index) => (
        <TableRow key={msg.id}>
          <TableCell className="text-center text-xs">{index + 1}</TableCell>
          <TableCell className="text-center text-xs">{msg.name}</TableCell>
          <TableCell className="text-center text-xs">{msg.category}</TableCell>
          <TableCell className="text-center text-xs">
            {typeof msg.content === "string"
              ? msg.content
              : JSON.stringify(msg.content)}
          </TableCell>
          <TableCell className="text-center text-xs">
            {msg.created_at ? new Date(msg.created_at).toLocaleString() : ""}
          </TableCell>
          <TableCell className="text-center text-xs">
            {msg.status === "sent" && (
              <span className="text-blue-600 font-semibold">Sent</span>
            )}
            {msg.status === "delivered" && (
              <span className="text-green-600 font-semibold">Delivered</span>
            )}
            {msg.status === "read" && (
              <span className="text-teal-600 font-semibold">Read</span>
            )}
            {msg.status === "failed" && (
              <span className="text-red-600 font-semibold">Failed</span>
            )}
            {msg.status === "pending" && (
              <span className="text-yellow-600 font-semibold">Pending</span>
            )}
          </TableCell>

          <TableCell className="text-center">
            <div className="flex justify-center">
              <Button
                size="small"
                layout="outline"
                style={{
                  padding: "2px 6px",
                  minWidth: "auto",
                  width: "auto",
                  fontSize: "0.8rem",
                  lineHeight: "1",
                  height: "30px",
                }}
                onClick={() => handleCheckClick(msg.id)}
                disabled={loadingId === msg.id}
              >
                {loadingId === msg.id ? "Checking..." : "Check"}
              </Button>
            </div>
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};

export default EmailTable;
